// blakfy-cookie/src/i18n/translations/pt.js — Portuguese translations

export default {
  title: "Preferências de Cookies",
  intro: "Este site usa cookies para melhorar sua experiência. Consulte nossa Política de Cookies.",
  policyLink: "Política de Cookies",
  acceptAll: "Aceitar todos",
  rejectAll: "Rejeitar todos",
  preferences: "Preferências",
  save: "Salvar escolhas",
  close: "Fechar",
  cat: {
    essential: {
      title: "Cookies essenciais",
      desc: "Necessários para o funcionamento do site. Não podem ser desativados.",
      always: "Sempre ativo",
    },
    analytics: {
      title: "Cookies analíticos",
      desc: "Usados para coletar estatísticas anônimas de visitas.",
    },
    marketing: {
      title: "Cookies de marketing",
      desc: "Usados para publicidade personalizada e retargeting.",
    },
    functional: {
      title: "Cookies funcionais",
      desc: "Usados para lembrar preferências como idioma e tema.",
    },
  },
  placeholder: {
    title: "Conteúdo bloqueado",
    desc: "Você precisa permitir cookies de {category} para ver este conteúdo.",
    cta: "Permitir",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
